import { render, staticRenderFns } from "./HuliIntro.vue?vue&type=template&id=a5acc778&scoped=true"
import script from "./HuliIntro.vue?vue&type=script&lang=js"
export * from "./HuliIntro.vue?vue&type=script&lang=js"
import style0 from "./HuliIntro.vue?vue&type=style&index=0&id=a5acc778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5acc778",
  null
  
)

export default component.exports